import type { ComponentType, ReactNode } from 'react';

import { PortalStaggerItem } from '@/modules/portal/components/ui/portal-motion';
import { cn } from '@/shared/lib/cn';

interface PortalKpiCardProps {
  label: string;
  children: ReactNode;
  icon?: ComponentType<{ className?: string }>;
  highlight?: boolean;
  className?: string;
}

export function PortalKpiCard({
  label,
  children,
  icon: Icon,
  highlight = false,
  className,
}: PortalKpiCardProps) {
  return (
    <PortalStaggerItem>
      <div
        className={cn('portal-kpi-card group', highlight && 'portal-kpi-card-highlight', className)}
      >
        <div className="flex items-start justify-between gap-3">
          <p className="text-sm font-medium text-muted-foreground">{label}</p>
          {Icon ? (
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary transition-colors group-hover:bg-primary/15">
              <Icon className="h-4 w-4" aria-hidden />
            </span>
          ) : null}
        </div>
        <div className="mt-3 min-w-0">{children}</div>
      </div>
    </PortalStaggerItem>
  );
}
